import React, { useState } from 'react';
import Link from 'next/link';
import Remove from '@mui/icons-material/Remove';
import Add from '@mui/icons-material/Add';
import IconButton from '@mui/material/IconButton';
import { collapseCategory } from '@/utils/categories';

type CategoryChildProps = {
  parent: MenuCategory;
  className?: string;
  toggleSectionBoxOpen?: () => void;
};

const CategoryChild = ({
  parent,
  className,
  toggleSectionBoxOpen
}: CategoryChildProps) => {
  const [categoryChildNode, setCategoryChildNode] = useState<CategoryNode>({});
  const [isNodeCollapsed, setIsNodeCollapsed] = useState(false);

  const collapse = (target: string) => {
    const newCategoryChildNode = categoryChildNode;

    collapseCategory(target, newCategoryChildNode, false, className);
    setCategoryChildNode(newCategoryChildNode);

    const nodeSectionBoxCollapsed =
      newCategoryChildNode[`sectionBoxCollapseFor${parent.name}`];
    setIsNodeCollapsed(
      nodeSectionBoxCollapsed
        ? nodeSectionBoxCollapsed.classList.contains(
            'section-box__link-box--collapseIn'
          )
        : false
    );
  };

  return (
    <div
      key={`category__${parent.name}`}
      className={`${className ?? ''} section-box__link-box${
        parent.defaultHide ? ' section-box__link-box--collapseIn' : ''
      } `}
      ref={(node) => {
        const newCategoryChildNode = categoryChildNode;
        if (newCategoryChildNode && node) {
          // console.log("newCategoryChildNode", newCategoryChildNode);
          newCategoryChildNode[`sectionBoxCollapseFor${parent.name}`] = node;
          setCategoryChildNode(newCategoryChildNode);
          // console.log("categoryChildNode", newCategoryChildNode);
          const nodeSectionBoxCollapsed =
            newCategoryChildNode[`sectionBoxCollapseFor${parent.name}`];
          setIsNodeCollapsed(
            nodeSectionBoxCollapsed
              ? nodeSectionBoxCollapsed.classList.contains(
                  'section-box__link-box--collapseIn'
                )
              : false
          );
        }
      }}
    >
      <div className='section-box__link-box__main'>
        {parent.link ? (
          <Link
            prefetch={false}
            href={parent.link}
            className='section-box__link'
          >
            {parent.name}
          </Link>
        ) : (
          <a href={parent.link} className='section-box__link'>
            {parent.name}
          </a>
        )}
        {parent.child && (
          <IconButton
            onClick={() => {
              collapse(parent.name);
            }}
            size='large'
          >
            {isNodeCollapsed ? <Add /> : <Remove />}
          </IconButton>
        )}
      </div>
      {parent.child && (
        <div
          className='section-box__link-box__children'
          ref={(node) => {
            if (node && categoryChildNode) {
              const newCategoryChildNode = categoryChildNode;
              newCategoryChildNode[`sectionBoxChildrenFor${parent.name}`] =
                node;
              setCategoryChildNode(newCategoryChildNode);
            }
          }}
          style={{ height: parent.defaultHide ? '0px' : 'auto' }}
        >
          <div
            className='section-box__link-box__children-inner'
            ref={(node) => {
              const newCategoryChildNode = categoryChildNode;
              if (newCategoryChildNode && node) {
                newCategoryChildNode[
                  `sectionBoxChildrenInnerFor${parent.name}`
                ] = node;
                setCategoryChildNode(newCategoryChildNode);
              }
            }}
          >
            {parent.child.map((child) => (
              <CategoryChild
                key={`category__${child.name}`}
                parent={child}
                toggleSectionBoxOpen={toggleSectionBoxOpen}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default CategoryChild;
